/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import EventImage from './event-image';
import EventImageDetail from './event-image-detail';
import EventImageUpdate from './event-image-update';
import EventImageDeleteDialog from './event-image-delete-dialog';

const EventImageRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<EventImage />} />
    <Route path="new" element={<EventImageUpdate />} />
    <Route path=":id">
      <Route index element={<EventImageDetail />} />
      <Route path="edit" element={<EventImageUpdate />} />
      <Route path="delete" element={<EventImageDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default EventImageRoutes;
